import CityPageTemplate from "../city-template/CityPageTemplate";
import { fremontCaConfig } from "./data";

export default function FremontCaPage() {
  return <CityPageTemplate config={fremontCaConfig} />;
}